import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getUser, updateUser, getCompanies } from '../services/api';
import './UserDetail.css';

function UserDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [editForm, setEditForm] = useState({ name: '', address: '', phone: '', company_id: null });

  const loadUser = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getUser(id);
      setUser(data.user);
      setEditForm({
        name: data.user.name || '',
        address: data.user.address || '',
        phone: data.user.phone || '',
        company_id: data.user.company_id ?? null,
      });
    } catch (err) {
      setError(err.message || 'Fehler beim Laden des Benutzers');
    } finally {
      setLoading(false);
    }
  }, [id]);

  const loadCompanies = useCallback(async () => {
    try {
      const data = await getCompanies();
      setCompanies(data.companies || []);
    } catch {
      setCompanies([]);
    }
  }, []);

  useEffect(() => {
    loadUser();
    loadCompanies();
  }, [loadUser, loadCompanies]);

  const handleSave = async () => {
    try {
      setSaving(true);
      setError('');
      await updateUser(id, {
        name: editForm.name || null,
        address: editForm.address || null,
        phone: editForm.phone || null,
        company_id: editForm.company_id ?? undefined,
      });
      await loadUser();
    } catch (err) {
      setError(err.message || 'Fehler beim Speichern');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="loading">Lade Benutzer-Details...</div>;
  }

  if (error && !user) {
    return <div className="error">{error}</div>;
  }

  if (!user) {
    return <div className="error">Benutzer nicht gefunden</div>;
  }

  return (
    <div className="user-detail">
      <h2>Benutzer-Details</h2>
      {error && <div className="error-message">{error}</div>}
      <div className="detail-card">
        <div className="detail-row">
          <strong>User-Nr (ID):</strong> {user.id}
        </div>
        <div className="detail-row">
          <strong>Email:</strong> {user.email}
        </div>
        <div className="detail-row">
          <strong>Name:</strong>
          <input
            type="text"
            value={editForm.name}
            onChange={(e) => setEditForm((f) => ({ ...f, name: e.target.value }))}
            className="detail-input"
          />
        </div>
        <div className="detail-row">
          <strong>Mandantennummer:</strong> {user.mandantennummer || '-'}
        </div>
        <div className="detail-row">
          <strong>Firma/Mandant:</strong>
          <select
            value={editForm.company_id ?? ''}
            onChange={(e) => setEditForm((f) => ({ ...f, company_id: e.target.value ? Number(e.target.value) : null }))}
            className="detail-input"
          >
            <option value="">– keine / Test-Firma –</option>
            {companies.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name} ({c.mandantennummer})
              </option>
            ))}
          </select>
        </div>
        <div className="detail-row">
          <strong>Adresse:</strong>
          <input
            type="text"
            value={editForm.address}
            onChange={(e) => setEditForm((f) => ({ ...f, address: e.target.value }))}
            className="detail-input"
          />
        </div>
        <div className="detail-row">
          <strong>Telefon:</strong>
          <input
            type="text"
            value={editForm.phone}
            onChange={(e) => setEditForm((f) => ({ ...f, phone: e.target.value }))}
            className="detail-input"
          />
        </div>
        <div className="detail-row">
          <strong>Status:</strong>
          <span className={`badge ${user.is_approved ? 'badge-success' : 'badge-warning'}`}>
            {user.is_approved ? 'Genehmigt' : 'Ausstehend'}
          </span>
        </div>
        <div className="detail-actions">
          <button type="button" className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Speichern…' : 'Speichern'}
          </button>
          <button type="button" className="btn btn-secondary" onClick={() => navigate('/admin/users')}>
            Zurück zur Liste
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserDetail;






